import React, {createContext, useContext, useEffect, useMemo, useState} from 'react';
import Icon from "../ui/components/Icon";
import {updateCurrentUser, USER_CURRENT_KEY} from "../api/public-voissa/users";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toastError} from "../libs/toast";
import {CURRENT_USER} from "../const/toasts";
import _ from "lodash";


const ContextBigPlan = createContext({
    bigPlanToggle: false,
    setBigPlanToggle: () => {},
});

const ProviderBigPlan = ({children}) =>{
    let isToggleDefault = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_gp`) === "true" ? true : false;

    const [bigPlanToggle, setBigPlanToggle] = useState(isToggleDefault);
    const value = useMemo(
        () => ({ bigPlanToggle, setBigPlanToggle }),
        [bigPlanToggle]
    );

    useEffect(() =>{
        localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_gp`, bigPlanToggle);
    }, [bigPlanToggle])

    return(
        <ContextBigPlan.Provider value={value}>
            {children}
        </ContextBigPlan.Provider>
    )
};

const BigPlanToggle = () => {
    const queryClient = useQueryClient();
    const { bigPlanToggle, setBigPlanToggle } = useContext(ContextBigPlan);
    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);

    const {
        mutate : mutateUpdateUser,
    } = useMutation(data => updateCurrentUser(data),{
        onSuccess: async () =>{
            await queryClient.invalidateQueries([USER_CURRENT_KEY]);
        },
        onError: () =>{
            toastError(CURRENT_USER.ERROR.UPDATE);
        }
    });

    const mutateBigPlan = () => {
        setBigPlanToggle(!bigPlanToggle);
        if(_.get(dataCurrentUser,'_id')){
            mutateUpdateUser({setting : {"displayBigPlan": !bigPlanToggle}});
        }
    };

    return (
        <div className={"cta-big-plan"} onClick={() => mutateBigPlan()}>
            {bigPlanToggle ? <><Icon type={"unlock"} /><span className="gros-plan-label lock"></span></> : <><Icon type={"lock"} /><span className="gros-plan-label unlock"></span></>}
        </div>
    );
};

export {
    ContextBigPlan,
    ProviderBigPlan,
    BigPlanToggle
}

